export default __webpack_public_path__ + "static/media/hash.deee7804.svg";